import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import ProcessIMG2 from  '../../../assets/images/nas-process-2.png'
import ProcessIMG3 from  '../../../assets/images/nas-process-3.png'
import ProcessIMG4 from  '../../../assets/images/nas-process-4.png'
import ProcessIMG5 from  '../../../assets/images/nas-process-5.png'
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'IT Monkeys NAS Synology',
    title: 'Incident reporting',
    titleKey: 'incidentCyber.timeline.services.1.title',
    description: 'In case of crisis, our team is available 24/7 to respond to your emergency calls.',
    descriptionKey: 'incidentCyber.timeline.services.1.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Rapid incident identification.' },
      { text: 'Response team activation.' },
      { text: 'Initial findings.' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Cybersecurity Icon',
    title: 'Control and containment',
    titleKey: 'incidentCyber.timeline.services.2.title',
    description: 'Our priority is to contain the incident to prevent any spread. We immediately isolate compromised systems from the rest of the network.',
    descriptionKey: 'incidentCyber.timeline.services.2.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Isolation of affected systems.' },
      { text: 'Spread prevention.' },
      { text: 'Evidence preservation.' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'OpenAI Icon',
    title: 'Eradication and remediation',
    titleKey: 'incidentCyber.timeline.services.3.title',
    description: 'Complete threat eradication, malware removal and system restoration.',
    descriptionKey: 'incidentCyber.timeline.services.3.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Malware and malicious access removal.' },
      { text: 'System and data restoration.' },
      { text: 'Vulnerability remediation.' },
    ],
  },
  {
    id: 4,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Cloud Service Icon',
    title: 'Forensic analysis',
    titleKey: 'incidentCyber.timeline.services.4.title',
    description: 'Our investigation experts conduct a complete forensic analysis to reconstruct the sequence of events and assess the extent of the impact.',
    descriptionKey: 'incidentCyber.timeline.services.4.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Complete digital investigation.' },
      { text: 'Source and method identification.' },
      { text: 'Damage extent assessment.' }
    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Training Icon',
    title: 'Post-incident and improvement',
    titleKey: 'incidentCyber.timeline.services.5.title',
    description: 'After incident resolution, our team intervenes on your IS to implement corrective measures.',
    descriptionKey: 'incidentCyber.timeline.services.5.description',
    link: '/training',
    features: [
      { text: '' },
      { text: 'Detailed incident report.' },
      { text: 'Intervention on your IS.' },
      { text: 'Post-incident security audit.' },
    ],
  },
];
